import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { deleteGroups, endDeleteGroups } from '../../store/actions/companies';
import { setCompaniesGroupFilterIds } from '../../store/actions/query';
import { retrieveCompanies } from '../../store/actions/search';

import DeleteGroupsModal from 'components/modals/delete_groups_modal';

export class CompaniesDeleteGroupModal extends React.Component {
  static propTypes = {
    deleteGroups: PropTypes.func.isRequired,
    deletingGroups: PropTypes.array,
    endDeleteGroups: PropTypes.func.isRequired,
    retrieveCompanies: PropTypes.func.isRequired,
    setCompaniesGroupFilterIds: PropTypes.func.isRequired
  };

  handleDeleteGroups = (groups) => {
    this.props.deleteGroups(groups);
    this.props.setCompaniesGroupFilterIds([]);
    this.props.retrieveCompanies();
  };

  render() {
    return (
      <DeleteGroupsModal
        groups={this.props.deletingGroups}
        shown={this.props.deletingGroups != null}
        onCancel={this.props.endDeleteGroups}
        onDelete={this.handleDeleteGroups}
      />
    );
  }
}

const mapStateToProps = state => ({
  deletingGroups: state.companies.deletingGroups
});

const mapDispatchToProps = {
  deleteGroups,
  endDeleteGroups,
  retrieveCompanies,
  setCompaniesGroupFilterIds
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesDeleteGroupModal);
